import { FC } from 'react';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Select from 'antd/lib/select';

import { supplierDescriptionFields } from 'components/Settings/fieldsConstants';

const { Option } = Select;

const SupplierDescription: FC = () => (
  <>
    <h4 className="mt-2.5 mb-5">Supplier Description</h4>
    <Row gutter={20}>
      {map(supplierDescriptionFields,
        ({ component: Component, componentProps, options, ...itemProps }, key) =>
          <Col span={12} key={key}>
            <Item {...itemProps} validateFirst>
              <Component size="large" placeholder={`Enter ${itemProps.label}`} {...componentProps}>
                {options && map(options, ({ id, description }) => <Option key={id} value={id}>{description}</Option>)}
              </Component>
            </Item>
          </Col>)}
    </Row>
  </>
);

export default SupplierDescription;
